const keys = ["retail",
    "wholesale",
    "coprorate",
    "government",
    "discount",
    "transient",
    "business",
    "leisure",
    "groups",
    "contracts",
    "others",
    "total"];

export default (year, month) => [
    ...[
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
        "Q1",
        "Q2",
        "Q3",
        "Q4",
        "YTD",
        "Year End"
    ].reduce((a, b, i) => {
        return [...a, {
            month_name: b, year_name: `${year} ${i < 12 ? i < month ? 'Actual' : 'Forecast ' : 'Actual'}`,
            ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
        }, {
            month_name: b, year_name: `${year} Budget`,
            ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
        }, {
            month_name: b, year_name: `${year - 1} Actual`,
            ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
        }]
    }, []),
    {
        month_name: `% to Budget ${~~year}`, year_name: `YTD Actual ${year}`,
        ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
    },
    {
        month_name: `% to Budget ${~~year}`, year_name: `Y/E Fcast ${year}`,
        ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
    },
    {
        month_name: `% to YTD Last Year`, year_name: `YTD Actual ${year}`,
        ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
    },
    {
        month_name: `Year End Mix %`, year_name: `Budget ${year}`,
        ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
    }, {
        month_name: `Year End Mix %`, year_name: `Act/Fcst ${year}`,
        ...keys.reduce((c, d) => ({ ...c, [`${d}_rn`]: 0, [`${d}_adr`]: 0, [`${d}_rev`]: 0 }), {})
    }
].map((x, i) => ({ ...x, sort: i }));


// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.2/data.js